import React from "react";
import PropTypes from "prop-types";

import classNames from "classnames";
import useOverviewContext from "../../store/use-overview-context";

const FiltersControlSorting = ({ id }) => {
  const { currentSorting, setSorting, resetSorting, loading } =
    useOverviewContext();

  const disabled = !!loading;

  const handleClick = (event, value, isSelected) => {
    event.preventDefault();
    if (disabled) return;
    if (isSelected) {
      resetSorting();
    } else {
      setSorting(id, value);
    }
  };

  const sortOrders = ["asc", "desc"];

  return (
    <>
      {sortOrders &&
        sortOrders.map((sortOrder, ix) => {
          const isCurrentSort = currentSorting === `${id}:${sortOrder}`;

          const buttonClasses = classNames({
            "filters-control": true,
            "filters-control-sorting": true,
            "filters-control-sorting--selected": isCurrentSort,
          });

          const iconClasses = classNames({
            icon: true,
            "icon-up": sortOrder === "asc",
            "icon-down": sortOrder === "desc",
            "icon-unknown": sortOrder !== "asc" && sortOrder !== "desc",
          });

          return (
            <button
              className={buttonClasses}
              disabled={disabled}
              title={sortOrder.label}
              onClick={(event) => handleClick(event, sortOrder, isCurrentSort)}
              key={ix}
            >
              <span className={iconClasses} />
              <span className="filters-control-sorting-label">
                {sortOrder.label}
              </span>
            </button>
          );
        })}
    </>
  );
};

FiltersControlSorting.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
};

export default FiltersControlSorting;
